import { faDollarSign } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { isMobile } from 'is-mobile'
import React, { Component } from 'react'
import NumberFormat, { NumberFormatValues } from 'react-number-format'

import './styles.css'

type Props = {
  value: string
  onChange: (value: string) => void
  onSubmit: () => void
}

export class AmountInput extends Component<Props> {
  amountChanged = (value: NumberFormatValues) => {
    this.props.onChange(value.formattedValue)
  }

  keyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.keyCode === 13) {
      this.props.onSubmit()
    }
  }

  render = () => (
    <div className="amount-input">
      <FontAwesomeIcon className="amount-input-prefix ml-1" icon={faDollarSign} />
      <NumberFormat
        type="text"
        pattern="[0-9]*"
        inputMode="numeric"
        allowNegative={false}
        thousandSeparator={true}
        decimalScale={2}
        className="amount-input-text"
        value={this.props.value}
        onValueChange={this.amountChanged}
        onKeyDown={this.keyPress}
        autoFocus={!isMobile()}
      />
    </div>
  )
}
